<template>
  <div id="ProviderDetail" class="row">
    <div class="col-12">
      <div class="banner">
            <CoolLightBox 
                :fullScreen="true"
                v-if="provider.bannerPhotos && provider.bannerPhotos.length > 0"
                :items="provider.bannerPhotos" 
                :index="bannerIndex"
                :effect="'fade'"
                @close="bannerIndex = null">
            </CoolLightBox>
            <swiper v-if="provider.bannerPhotos && provider.bannerPhotos.length > 0" class="swiperBannder" :options="swiperBanner">
                    <swiper-slide v-for="(banner, index) in provider.bannerPhotos" :key="index" >
                        <img class="banner-photos" @click="bannerIndex == -1 ? -1 : bannerIndex = index" :src="banner" alt="error image">
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
            <div v-else class="swiperBannder shadow-lg"></div>
      </div>
    </div>
    <div class="col-12">
      <div class="caption">
        <div class="d-flex flex-row">
           <CoolLightBox 
                :fullScreen="true"
                v-if="providerAvatar && providerAvatar.length > 0"
                :items="providerAvatar" 
                :index="avatarIndex"
                :effect="'fade'"
                @close="avatarIndex = null">
            </CoolLightBox>
            <img class="avatar" @click="avatarIndex = 0" :src="provider.avatar"/>
           <!-- <img class="avatar" @click="avatarIndex = 0" :src="provider.avatar ? provider.avatar : defaultAvatar"/> -->
          <div class="d-flex flex-column pl-3">
            <h3 class="display-xs-1 font-weight-bold pt-2 mb-0 pt-lg-3">
              {{provider.displayName}}
              <span class="verified-tag" v-if="provider.showVerifiedIcon"></span>
            </h3>
            <star-rating :star-size="12" inactive-color="#ffffff" :border-width="3" border-color="#FFBE17" text-class="text-secondary font-weight-bold" class="pb-2 pb-lg-2"  :rating="caculateRating(provider.totalStar, provider.totalRate)" :read-only="true" :increment="0.1">
            </star-rating>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-5 ml-0 ml-md-3">
        <div class="row no-gutters">
            <div class="col-6 col-lg-12">
                <div v-if="provider.phones && provider.phones.length > 0 || provider.emails && provider.emails.length > 0 " class="col-12 mt-3 mb-3 pl-1 pr-1">
                    <div class="card border-orange">
                        <div class="card-header custom-card-header text-secondary border-orange bg-primary font-weight-bold heading-primary">{{$t('provider_detail.contact.name')}}</div>
                        <div class="card-body custom-card-body">
                            <div v-if="provider.phones && provider.phones.length > 0" class="mb-1 card-title text-secondary font-weight-bold">
                                {{$t('provider_detail.contact.phone')}}
                            </div>
                            <div class="card-text mt-2" v-for="phone in provider.phones" :key="phone">
                                <a class="text-secondary" target="_blank" :href="'tel:'+phone">{{ phone }}</a>
                            </div>
                            <div v-if="provider.emails && provider.emails.length > 0" class="mb-1 mt-3 card-title text-secondary font-weight-bold">
                                Email
                            </div>
                            <div class="card-text mt-2" v-for="email in provider.emails" :key="email">
                                <a class="text-secondary" target="_blank" :href="'mailto:'+email">{{ email }}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="locations && locations.length > 0" class="col-12 mt-3 mb-3 pl-1 pr-1">
                    <div class="card border-orange">
                        <div class="card-header custom-card-header text-secondary border-orange  bg-primary font-weight-bold heading-primary">{{$t('provider_detail.locations')}}</div>
                        <div class="card-body custom-card-body">
                            <div
                                class="card-text card-location pt-2 pb-2"
                                v-for="location in locations"
                                :key="location._id"
                            >
                                <a class="text-secondary" :href="'https://www.google.com/maps/place/'+encodeURIComponent(location.address)" target="_blank">{{ location.address }}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="provider.introduction" class="col-12 mt-3 mb-3 pl-1 pr-1">
                    <div class="card border-orange">
                        <div class="card-header custom-card-header border-orange bg-primary font-weight-bold heading-primary">{{ $t('provider_detail.introduction') }}</div>
                        <div class="card-body custom-card-body">
                            <p v-if="provider.introduction" class="card-text">{{ provider.introduction }}</p>
                            <p v-else class="card-text"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-12" v-if="services && services.length > 0">
                 <div class="col-12 mt-3 mb-3 pl-1 pr-1">
                      <!-- <Feedback :providerId="providerId"></Feedback> -->
                      <Feedback :providerId="providerId" :services="services"></Feedback>
                </div>
            </div>
        </div>    
    </div>
    
    <div class="col-12 col-lg-6 mt-3 mb-3 p-0"  v-if="services && services.length > 0" >
      <div class="panel-right">
        <div class="panel-right-body">
            <PriceList :services="services"> </PriceList>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .swiper-button-prev,
  .swiper-button-next {
    color: #ffbe17;
  }

  .swiper-pagination-bullet {
    color: #ffbe17;
    border-radius: 0px;
    width: 30px;
    height: 5px;
    background-color: #ffbe17;
  }

  .vue-star-rating-rating-text::after {
    content: "/5";
  }

</style>
<style lang="scss" scoped>
  .verified-tag {
    background-color: red;
    width: 20px;
    height: 22px;
    display: inline-block;
    background: url("/verified.svg") center no-repeat;
    background-size: 18px;
  }

  #ProviderDetail {
    font-size: 12px;
  }

  .text-black{
     color: black;
  }

  .heading-primary {
    font-size: 14px;
  }


  .text-word-break {
    word-break: break-all;
  }
  
  .card-location:not(:last-child) {
    border-bottom: 1px solid #ffefc5;
  }

  .text-date {
    color: #999999;
    font-size: 10px;
  }
  .border-orange {
    border: 1px solid #ffefc5;
  }

  .custom-card-header{
     padding: 10px 6px;
  }
  .custom-card-body{
    padding: 10px 6px;
  }

.caption{
    .avatar{
        z-index: 1;
        border-radius: 45px;
        width: 120px;
        height: 120px;
        margin: -30px 0px 0px 7px; 
        border: 1px solid #F2F2F2;
        box-shadow: 
            0 1px 5px #999999,
            0 2px 10px #999999,
            0 3px 15px #999999;
    }
    h3{ 
        font-size: 15px;
    }

}
.banner {
    .swiperBannder{
       height:  300px;
       width: 100%; 
    }
    &-photos{
        object-fit: cover; 
        width: 100%;
        color: black;
        height: inherit;
        overflow: hidden;
        height: 100%;
        border-radius: 14px;
    }
}  


.panel-right {
  position: relative;
  &::before {
    content: "";
    background-color: #ffbe17;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: -999px;
    border-radius: 20px;
  }

  .title-price-list {
    font-size: 16px;
  }
  
  .panel-right-body {
    position: relative;
    padding: 20px 15px;
  }

}



@media screen and (min-width: 1024px) {
  #ProviderDetail {
    font-size: 14px;
  }

  .custom-card-header{
    padding: 10px 15px;
  }

  .custom-card-body{
    padding: 10px 15px;
  }

  .text-date {
    font-size: 12px;
  }

  .heading-primary {
    font-size: 16px;
  }

  .caption {
    .avatar {
      width: 140px;
      height: 140px;
      margin: -40px 0px 0px 20px;
    }
    h3 {
      font-size: 20px;
    }
  }

  // .panel-right {
  //   .title-price-list {
  //     font-size: 16px;
  //   }
  //   #card-quotation {
  //     .card-header {
  //       .price-size {
  //         position: relative;
  //         font-size: 20px;
  //       }
  //       .text-unit {
  //         position: absolute;
  //         color: #e9cc81;
  //         padding: 0px 1px;
  //         font-size: 12px;
  //       }
  //     }
  //   }
  // }
}

.swiper-slide {
  height: auto;
}

</style>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import StarRating from "vue-star-rating";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import PriceList from "@/components/PriceList.vue";
import Feedback from "@/components/Feedback.vue";

export default {
  name: "ProviderDetail",
  components: {
    Swiper,
    SwiperSlide,
    StarRating,
    CoolLightBox,
    PriceList,
    Feedback
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      providerId: "",
      provider: {},
      locations: [],
      services: [],
      quotations: [],
      providerAvatar: [],
      defaultAvatar: require('../assets/default-avatar.svg'),
      defaultBanner: require('../assets/sink-fixed.png'),
      bannerIndex: '',
      avatarIndex: '',
      swiperBanner: {
        slidesPerView: 1,
        spaceBetween: 30,
        keyboard: {
          enabled: true
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
        isActive: false,
        user: {}
    }
  },
  methods: {
    caculateRating(totalStar, totalRate) {
      let results = totalStar / totalRate;
      if (totalStar == 0 && totalRate == 0) {
        return 0;
      }
      if (results % 1 != 0) {
        results = results.toFixed(1);
      }

      return Number(results);
    },
    async getLocationsByProviderId(providerId) {
      try {
        const {
          data: { results }
        } = await this.$store.$oddjob.serviceProviders.getLocations(providerId);
        if (results && results.length > 0) {
          return results;
        }
        return [];
      } catch (e) {
        console.log("API locations failed", e);
      }
    },
     async getCategoryById(categoryId) {
      try {
        const {
          data: { results }
        } = await this.$store.$oddjob.settings.getCategoryById(categoryId);
        if (results && results.length > 0) {
          return results[0];
        }
        return {};
      } catch (e) {
        console.log("API category failed");
      }
    },
    async getServicesByProviderId(providerId) {
      try {
        let {
          data: { results }
        } = await this.$store.$oddjob.serviceProviders.getServicesByProviderId(
          providerId
        );
        if (results && results.length > 0) {
          results = results.reduce((newArray, item) =>{
            if(item.status === 'active'){
              newArray.push(item);
            }
            return newArray;
          }, []);
          return Promise.all(results.map(async (service) => {
             service.category = await this.getCategoryById(service.category);
             return service;
          }));
        }
        return [];
      } catch (e) {
        console.log("API service failed", e);
      }
    },
    async reloadData(){
          console.log("providerID", this.providerId);
          this.providerAvatar = [];
          const { data: { results } } = await this.$store.$oddjob.serviceProviders.getProviderById(this.providerId);
          if(results && results.length > 0){

              this.services = await this.getServicesByProviderId(this.providerId);
              
              this.provider = results[0];

              this.provider.avatar ? this.providerAvatar.push(this.provider.avatar.replace("small", "origin")) : this.provider.avatar = this.defaultAvatar; 
              this.provider.displayName = this.provider.displayName ? this.provider.displayName : this.provider.fullName ? this.provider.fullName : "No Name";

              this.locations = await this.getLocationsByProviderId(this.providerId);

              if(this.provider.bannerPhotos && this.provider.bannerPhotos.length > 0){
                this.provider.bannerPhotos = this.provider.bannerPhotos.map(item => {
                    return item.replace("small", "origin");
                })  
              }else{
                // this.provider.bannerPhotos.push(this.defaultBanner);
                this.bannerIndex = -1;
              }

              console.log("provider", this.provider);
              console.log("locations", this.locations);
              console.log("services", this.services);
        }
    }
  },
  async mounted() {
    // try {
    //   if (this.$route.params.id && this.$route.params.id) {
    //     this.providerId = this.$route.params.id;
    //     await this.reloadData();
    //   }
    // } catch (e) {
    //   console.error(e);
    // }
  },
  async created(){
     try {
      if(this.$route.params.serviceId && this.$route.params.serviceId){
        if (this.$route.params.id && this.$route.params.id) {
          this.$store.dispatch("saveParameterSeviceId", this.$route.params.serviceId);
          this.providerId = this.$route.params.id;
          await this.reloadData();
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
};
</script>
